





















































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import MswAppTitle from '@/shared/msw-app-title/msw-app-title.vue';
import { SwTable, TableColumnConfig, TableEntrySelectingEventData, SortedColumnInfo, ColumnSortRequestData } from '@libs-uuif/shared/sw-table';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
// import { CreateElement, VNode } from 'vue';
// import ManageCaseDeatil from './components/manage-case-detail.vue';
import SpecificCaseDetails from './components/specific-case-details.vue';
import SupportCaseSlider from './components/support-case-slider.vue';
// import _ from 'lodash';
import { TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SetHelpContentIdPayload } from '@/core';
import { Mutation } from 'vuex-class';
const cssPrefix = 'manage-cases';
@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTable,
    SwDropMenu,
    SwIconButton,
    SwIcon,
    SwExpandableTextfield,
    SwTextfield,
    SwTabGroup,
    SwTabPage,
    SwSelect,
    SupportCaseSlider,
    SpecificCaseDetails,
  },
})
export default class MswManageCases extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  tabsProps: TabProps[] = [
    { tabId: 'reqInformation', label: 'REQUEST INFORMATION' },
    { tabId: 'reqHistory', label: 'REQUEST HISTORY' },
  ];
  get filterItems(): DropMenuItem[] {
    return [
      { id: 'status', content: 'Status' },
      { id: 'caseno', content: 'Case Number' },
      { id: 'subject', content: 'Subject' },
      { id: 'createddate', content: 'Created Date' },
      { id: 'product', content: 'Product' },
      { id: 'serno', content: 'Serial Number' },
      { id: 'priority', content: 'Priority' },
      { id: 'caseType', content: 'Case Type' },
    ];
  }
  selectedTab: string = 'reqInformation';
  menuOpened: boolean = false;
  search: string = '';
  textExpanded: boolean = false;
  appliedFilter: any = [];
  addFilterOptionBack: any = [];
  showFilterSearch : boolean = false;
  filterSearch: string = '';
  showSearchedTextInHeader : boolean = false;
  manageCaseColHeading: TableColumnConfig[] = this.tableColConfigArr();
  tableData: TableEntry[] = [];
  tempTableData: any = [];
  sortedColumns: SortedColumnInfo[] = [];
  showSupportCaseSlider: boolean = false;
  showDetailModal: boolean = false;
  changeInHeight: boolean = true;
  caseDetailsData: string = '';
  tableColConfigArr(): TableColumnConfig[] {
    return [
      {
        key: '_key',
        dataKey: '_key',
        title: '#',
        width: 80,
      },
      // {
      //   key: 'expand',
      //   type: 'expand',
      //   // tslint:disable-next-line
      //   render: (h: CreateElement, data: any): VNode => {
      //     return (
      //       <div style="margin: 32px">
      //       <ManageCaseDeatil caseDetails={JSON.stringify(data.entry)} />
      //       </div>
      //       ) as VNode;
      //   },
      // },
      {
        key: 'status',
        dataKey: 'status',
        title: (this.$t('manageCase.status')
        .toString()),
        sorter: true,
      },
      {
        key: 'caseno',
        dataKey: 'caseno',
        title: (this.$t('manageCase.caseNo')
        .toString()),
        sorter: true,
      },
      {
        key: 'subject',
        dataKey: 'subject',
        title: (this.$t('manageCase.subject')
        .toString()),
        sorter: true,
      },
      {
        key: 'createddate',
        dataKey: 'dtcreateddate',
        title: (this.$t('manageCase.createdDate')
        .toString()),
        sorter: true,
        render: (createElement, data: { entry: TableEntry }) => {
          return createElement('div', { domProps: { innerHTML: data.entry.createddate } });
        },
      },
      {
        key: 'product',
        dataKey: 'product',
        title: (this.$t('manageCase.product')
        .toString()),
        sorter: true,
      },
      {
        key: 'serno',
        dataKey: 'serno',
        title: (this.$t('manageCase.serNum')
        .toString()),
        sorter: true,
      },
      {
        key: 'priority',
        dataKey: 'priority',
        title: (this.$t('manageCase.priority')
        .toString()),
        sorter: true,
      },
      {
        key: 'caseType',
        dataKey: 'caseType',
        title: (this.$t('manageCase.caseType')
        .toString()),
        sorter: true,
      },
    ];
  }

  created() {
    this.setHelpId('managecases');
    this.getCasesRecord();
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking route', this.$route.query.mode === 'APP');
      this.changeInHeight = true;
    } else {
      this.changeInHeight = false;
    }
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  destroyed() {
    this.setHelpId('default');
  }

  onRequestSorting(data: ColumnSortRequestData) {
    /** for now, we only support single-column sorting */
    // console.warn(this.sortedColumns);
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        this.sortedColumns.push({
          colKey: data.colKey,
          ascending: !!data.ascending,
        });
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  getCasesRecord(val: string = '') {
    console.warn(val);
    this.$store.dispatch('MswSupportCasesModule/getSupportRecord')
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'SUCCESS') {
          this.tableData = resp.content.getSupportRecord;
          this.tableData.forEach((item: any, index: number) => {
            item['_key'] = index + 1;
          });
          this.tempTableData = this.tableData;
          if (val !== 'refresh') {
            if (val === 'onManageCasePage' || (this.$route.query && this.$route.query.newCase === 'created')) {
              const caseDeatils: any = this.tableData[0];
              this.caseDetailsData = JSON.stringify(caseDeatils);
              this.showDetailModal = true;
            }
          }
          // else if (showLatestCase === 'fromManageCasePage') {
          //   this.caseDetailsData = JSON.stringify(this.tableData[0]);
          //   console.warn(this.caseDetailsData);
          //   this.showDetailModal = true;
          // }
        }
      });
  }
  onFilterClick(filterItem : any) {
    this.appliedFilter.map((ele: any, i: number) => {
      if (ele.value === '') {
        this.addFilterOptionBack.map((item: any, j: number) => {
          if (item.data.id === ele.id) {
            this.filterItems.splice(item.index, 0, item.data);
            this.addFilterOptionBack.splice(j, 1);
          }
        });
        this.appliedFilter.splice(i, 1);
      }
    });
    this.menuOpened = false;
    let removeIndex : number = -1;
    this.filterItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        { id: this.filterItems[removeIndex].id,
          content: this.filterItems[removeIndex].content,
          value: '',
        });
      this.filterSearch = '';
      this.showFilterSearch = true;
      this.addFilterOptionBack.push({
        index: removeIndex,
        data: this.filterItems[removeIndex],
      });
      this.filterItems.splice(removeIndex, 1);
    }
    setTimeout(() => {
      const filterInput = document.getElementById('filterTextField') as HTMLElement;
      console.warn(filterInput);
      if (filterInput) {
        filterInput.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }
  initiateFilter(event : any, filterId : any) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }
  setFilterValue(event = undefined, id: any) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(id);
    } else {
      this.appliedFilter.forEach((element : any) => {
        if (element.id === id) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }
  applyFilter(isExternal: boolean = false) {
    if (!isExternal) {
      this.tableData = this.tempTableData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        this.tableData = this.tableData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          const srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['status', 'caseno', 'subject', 'createddate', 'product', 'serno', 'priority'];
      this.tableData = this.tableData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
  }
  removeFilterBox(val: any) {
    let removeIndex = -1;
    this.filterSearch = '';
    this.appliedFilter.forEach((element : any, i : number) => {
      if (element.id === val) {
        element.value = '';
        removeIndex = i;
      }
    });
    this.appliedFilter.splice(removeIndex, 1);
    this.addFilterOptionBack.map((item: any, i: number) => {
      if (item.data.id === val) {
        this.filterItems.splice(item.index, 0, item.data);
        this.addFilterOptionBack.splice(i, 1);
      }
    });
    this.applyFilter();
  }
  onClickRow(data: TableEntrySelectingEventData) {
    const i: any = parseInt(data.entryKey, 10) - 1;
    const seletectedRow =  this.tempTableData[i];
    this.caseDetailsData = JSON.stringify(seletectedRow);
    this.showDetailModal = true;
  }
  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }
  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.addFilterOptionBack.map((item: any) => {
      this.filterItems.splice(item.index, 0, item.data);
    });
    this.addFilterOptionBack = [];
    this.applyFilter();
  }
  onSelectItem(val: any) {
    this.selectedTab = val;
  }
  closeSupportCaseSlider() {
    this.showSupportCaseSlider = false;
  }
  closeCaseDetailsModal() {
    this.showDetailModal = false;
  }
  openSupportSlider() {
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking route', this.$route.query.mode === 'APP');
      window.parent.postMessage({
        showSupportSlider : true,
      },                        '*');
    } else {
      this.showSupportCaseSlider = true;
    }
  }
}
